// Account managers tab — book ownership per AM (+ Unassigned + All).
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { vApi, gbp, STATUS_COL } from "./_shared";

const td = "px-2.5 py-2 whitespace-nowrap";
const Mix = ({ r }) => (
  <div className="flex h-2 w-28 rounded-full overflow-hidden bg-white/5">
    {["active", "cooling", "lapsed", "dormant"].map((k) => <span key={k} style={{ width: `${r.book ? (100 * r[k]) / r.book : 0}%`, background: STATUS_COL[k[0].toUpperCase() + k.slice(1)] }} />)}
  </div>
);

export default function AmsTab({ onPick }) {
  const [d, setD] = useState(null);
  useEffect(() => { vApi.get("/ams").then(setD).catch(() => setD({ rows: [], all: null })); }, []);
  if (!d) return <div className="p-8 grid place-items-center"><Loader2 className="w-5 h-5 animate-spin text-slate-500" /></div>;
  const H = ["AM", "Book", "Active", "Cooling", "Lapsed", "Dormant", "Mix", "% Active", "Revenue 30d", "Revenue 90d", "Repeat %", "Top value", "Win-back LTV"];
  const Row = ({ r, all }) => (
    <tr onClick={() => !all && onPick(r.am === "Unassigned" ? "unassigned" : r.am)} className={`border-t border-white/[0.04] ${all ? "bg-white/[0.03] font-semibold" : "hover:bg-white/[0.03] cursor-pointer"}`} data-testid={`velocity-am-row-${r.am}`}>
      <td className={`${td} ${r.am === "Unassigned" ? "text-amber-300" : "text-slate-100"}`}>{r.am}</td><td className={`${td} text-right`}>{r.book}</td>
      {["active", "cooling", "lapsed", "dormant"].map((k) => <td key={k} className={`${td} text-right tabular-nums`}>{r[k]}</td>)}
      <td className={td}><Mix r={r} /></td><td className={`${td} text-right`}>{r.pct_active}%</td><td className={`${td} text-right tabular-nums`}>{gbp(r.rev30)}</td>
      <td className={`${td} text-right tabular-nums text-white`}>{gbp(r.rev90)}</td><td className={`${td} text-right`}>{r.repeat_pct}%</td><td className={`${td} text-right`}>{r.top}</td><td className={`${td} text-right tabular-nums`}>{gbp(r.winback_ltv)}</td>
    </tr>);
  return (
    <div data-testid="velocity-ams">
      <div className="px-4 py-2.5 text-[11.5px] text-slate-400 border-b border-white/5" data-testid="velocity-ams-banner">Revenue is credited to the customer's current AM — ownership of the book, not effort. Click a row to filter the page to that AM.</div>
      <div className="overflow-x-auto"><table className="w-full text-[12.5px]">
        <thead className="bg-white/[0.02]"><tr>{H.map((h, i) => <th key={h} className={`px-2.5 py-2 font-mono uppercase tracking-widest text-[10px] text-slate-500 ${i === 0 || h === "Mix" ? "text-left" : "text-right"}`}>{h}</th>)}</tr></thead>
        <tbody>{d.rows.map((r) => <Row key={r.am} r={r} />)}{d.all && <Row r={d.all} all />}</tbody>
      </table></div>
    </div>
  );
}
